export function normalizeUserId(value) {
  const visited = new Set();

  function normalize(candidate) {
    if (candidate === null || candidate === undefined) return null;
    if (typeof candidate === 'string' || typeof candidate === 'number') {
      const normalized = String(candidate).trim();
      return normalized || null;
    }
    if (typeof candidate !== 'object' || visited.has(candidate)) return null;
    visited.add(candidate);

    if (typeof candidate.toHexString === 'function') {
      try {
        return normalize(candidate.toHexString());
      } catch (error) {
        return null;
      }
    }

    for (const key of ['id', '_id', 'ObjectId', '$oid', 'oid']) {
      if (candidate[key] !== undefined) {
        const normalized = normalize(candidate[key]);
        if (normalized) return normalized;
      }
    }
    return null;
  }

  return normalize(value);
}

export function isAssignedToUser(ticket, userId) {
  const normalizedUserId = normalizeUserId(userId);
  if (!normalizedUserId) return false;

  return [
    ticket?.assigned_pic_user_ref_id,
    ticket?.assignee?.id ?? ticket?.assignee?._id,
  ].some(assignedId => normalizeUserId(assignedId) === normalizedUserId);
}

export function indexUsersById(users) {
  return (users || []).reduce((lookup, user) => {
    const userId = normalizeUserId(user);
    if (userId) lookup[userId] = user;
    return lookup;
  }, {});
}

export function buildCategoryPicMapsByCategory(mappings) {
  return (mappings || []).reduce((lookup, mapping) => {
    const categoryId = mapping?.category_ref_id;
    if (!categoryId) return lookup;
    if (!lookup[categoryId]) lookup[categoryId] = [];
    lookup[categoryId].push(mapping);
    return lookup;
  }, {});
}

export function resolveBackupUser(
  { categoryRefId, mainPicId },
  categoryPicMapsByCategory,
  usersById,
) {
  const mappings = categoryPicMapsByCategory[categoryRefId] || [];
  const activeMappings = mappings.filter(mapping => mapping.is_active !== false);
  if (activeMappings.length === 0) return null;

  const selectedMapping =
    activeMappings.find(mapping => normalizeUserId(mapping.pic_user_ref_id) === normalizeUserId(mainPicId)) ||
    activeMappings.find(mapping => mapping.is_default) ||
    activeMappings[0];

  return usersById[normalizeUserId(selectedMapping.backup_user_ref_id)] || null;
}
